import React from 'react'
import { Box } from '@mui/material'
import SlugTable from '../utils/SlugTable'
import AddressSearchBox from '../utils/AddressSearch'
import { useLocation, useNavigate, createSearchParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { AppUser, authStatus, selectAuthUser, selectIsAuth, selectIsNotOrgUser } from '../auth/AuthSlice'
import { clearSlug } from '../analysis/AnalysisSlice'

function Home() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const authUser = useAppSelector(selectAuthUser)
  const isNotOrgUser = useAppSelector(selectIsNotOrgUser)
  const authProfileStatus = useAppSelector(authStatus)

  return (
    <>
      <AddressSearchBox showCredits={authProfileStatus === 'idle'} credits={authUser?.paidTierCount}
        orgCredits={!isNotOrgUser ? authUser?.org?.paidTierCount : 0} onAddressSelect={(address: string, search: string) => {
          setTimeout(() => {
            dispatch(clearSlug())
            navigate({
              pathname: (authUser?.paidTierCount && authUser?.paidTierCount <= -10 && isNotOrgUser) ? `/subscription/price` : `/analysis/addr/${address}`,
              search
            })
          }, 500)
        }} />
      <Box sx={{ mt: 5 }}>
        <SlugTable mode='my' />
      </Box>
    </>
  )
}

export default Home
